<section class="safetyinspectionrow">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="white_fonts">
                    <div class="row animate__animated animate__fadeInUp top">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <header class="section-header">
                                <h3>On-Site Inspections</h3>
                            </header>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-12">
                        <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                            <strong>Our safety inspections</strong> help turn your safety program into daily action.
                        </h3>

                        <p class="theme_color fontSize" data-aos="fade-up" data-aos-delay="200">
                            As an essential part of a strong safety program, SFI safety inspections help identify hazards,
                             reinforce safe work practices, and reduce the potential for injuries and accidents. 
                             Our consultants work with management, supervisors, and employees through coaching, training, 
                             and positive reinforcement to strengthen safety performance in the field.
                             Supervisors play a critical role in maintaining a safe workplace between SFI visits. 
                             Our consultants provide them with practical guidance,
                            tools, and support to recognize hazards, address unsafe conditions, and reinforce expectations every day.
                        </p>
                        <p class="theme_color fontSize">
                            <strong>Beyond Compliance approach helps build accountability, strengthen safety culture, and make safe work
                             practices part of how the job gets done.</strong> 
                        </p>

                        <img src="../../assets/images/safetyinspectionslatest.jpg" class="img-fluid" data-aos="fade-up" data-aos-delay="300"/>
                        <p></p>

                        <h3 class="theme_color" data-aos="fade-up" data-aos-delay="50">
                            <strong>We offer these types of workplace safety inspection services:</strong>
                        </h3>
                    </div>
                </div>

                <div class="row" >
                    <div class="col-lg-12">
                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="100">
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;<strong>Comprehensive Safety Review</strong></span></li>
                            <p class="theme_color fontSize">
                                SFI Safety provides an in-depth evaluation of your current safety program, workplace conditions, and overall safety practices. The scope and duration of the review will vary depending on the size and complexity of your operation.
                            </p>

                            <p class="theme_color fontSize">
                                A comprehensive safety review provides a valuable baseline for future improvement. It helps identify strengths, gaps, and opportunities to improve your safety program while creating a clear path toward stronger performance and a safer workplace.
                            </p>
                        </ul>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="150">
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;<strong>Ongoing On-Site Safety Inspections</strong></span></li>
                            <p class="theme_color fontSize">
                                Our safety consultants provide recurring workplace and jobsite inspections with detailed reports identifying hazards, positive observations, and recommendations for improvement.
                            </p>

                            <p class="theme_color fontSize">
                                Whenever possible, hazards are corrected during the inspection and documented in the report. 
                                When immediate correction is not possible, our consultants work with supervisors to establish 
                                appropriate corrective actions and track abatement to completion.
                            </p>

                            <p class="theme_color fontSize">
                                Ongoing inspections help your organization go Beyond Compliance by reinforcing accountability, 
                                identifying trends, and addressing hazards before they result in injuries or incidents.
                            </p>

                           
                        </ul>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="200">
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;<strong>OSHA Inspection Assistance</strong></span></li>
                            <p class="theme_color fontSize">
                                If OSHA visits your workplace or jobsite, SFI Safety can assist throughout the inspection process. Our consultants help communicate your safety efforts, documentation, corrective actions, and the positive steps your organization has taken to protect employees.
                            </p>

                            <p class="theme_color fontSize">
                                Following the inspection, we can assist with corrective actions, abatement certifications, documentation, and informal conference support when appropriate.
                            </p>
                        </ul>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="250">
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;<strong>Workplace Accident and Incident Investigations</strong></span></li>
                            <p class="theme_color fontSize">
                                Accidents, injuries, near misses, and other incidents should be thoroughly investigated to determine contributing factors and root causes. Our safety consultants help identify what occurred, why it occurred, and what actions can be taken to reduce the likelihood of recurrence.
                            </p>

                            <p class="theme_color fontSize">
                                Effective investigations go beyond documenting an event. They provide valuable information that can strengthen training, improve procedures, and prevent similar incidents in the future.
                            </p>
                        </ul>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="300">
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;<strong>Ongoing Safety Training During Safety Inspections</strong></span></li>
                            <p class="theme_color fontSize">
                                Training is an ongoing process. During our safety inspections, our safety consultants train employees and subcontractors to minimize repeat infractions.
                            </p>

                            <p class="theme_color fontSize">
                                We handle safety infractions in a positive manner, by explaining why it’s a hazard or OSHA violation and teaching the workers how to correct the problem. We also explain and train the workers the reasoning behind the safety issue in question.
                            </p>
                        </ul>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="350">
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;<strong>Comprehensive Reporting and Safety Data</strong></span></li>
                            <p class="theme_color fontSize">
                                SFI Safety inspections are documented through the SFI Safety App, giving clients secure access to inspection reports, photographs, corrective actions, trends, and other measurable safety information.
                            </p>

                            <p class="theme_color fontSize">
                                Reports are available electronically and provide management with better visibility into safety performance across projects and operations. This information helps organizations identify recurring issues, measure improvement, strengthen accountability, and make more informed safety decisions.
                            </p>
                        </ul>
                    </div>
                </div>
                <div>
                    <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                        <strong>Our inspections are designed to do more than identify hazards. 
                            They help clients build stronger systems, improve accountability,
                             and create measurable safety performance that goes Beyond Compliance.</strong> 
                    </h3>
                </div>
            </div>

            <!-- <div class="col-lg-4" style="background-color: #f8f9fa;" data-aos="fade-left" data-aos-delay="300">
                <div class="row">
                    <div class="col-lg-12">
                        <br/>
                        <img src="../../assets/images/dms.jpeg" class="img-fluid">
                        <p></p>
                        <h3 class="theme_color fontSize">
                            <strong>Measure the success of your safety program online, anytime!</strong>
                        </h3>
                        <p class="fontSize">
                            As an industry leader in construction safety, SFI Compliance is proud to offer our exclusive web-based Safety Data Management System (DMS) application to our clients. Easily review a variety of measurable statistics, reporting and scoring features. You can also allow as many internal users within your organization to access the system with unique login IDs and user permissions, so everyone has access to the same data at the same time.
                        </p>

                        <h3 class="fontSize">
                            <strong>Real-time construction safety results, 24/7</strong>
                        </h3>
                        <p class="fontSize">
                            Your private Safety DMS portal allows you real-time access to your OSHA Compliance and job site safety inspection reports data throughout your organization at any time.
                        </p>                      

                        <h3 class="fontSize">
                            <strong>Automatic notifications</strong>
                        </h3>
                        <p class="fontSize">
                            Our system features automatic e-mail notifications when your new inspection reports are published so you will have immediate access to them.
                        </p>

                        <h3 class="fontSize">
                            <strong>See an online demonstration</strong>
                        </h3>
                        <p class="fontSize">
                            <a href="/contact" class="theme_color fontRed"><u><strong>Contact us</strong></u></a> for an online demonstration or for more information about our exclusive Safety Data Management System.
                        </p>

                        <p class="fontSize">
                            Having issues with the DMS site or app? Visit our <a href="/" class="theme_color fontRed"><u><strong>FAQ’s</strong></u></a> here
                        </p>

                        <h3 class="fontSize">
                            <strong>Now available! DMS Mobile App </strong>
                        </h3>
                        <img src="../../assets/images/mobile-tablet.png"  class="img-fluid" data-aos="fade-left" data-aos-delay="300"><br/>

                        <span class="smallfontsize"><strong>Through the app users will soon be able to:</strong></span>

                        <div class="row" style="padding-top: 10px;padding-bottom: 10px;">
                            <div class="col-lg-6 col-6 text-center">
                                <a href="https://play.google.com/store/apps/details?id=com.sfi.mobileapp" target="_blank"><i class="fa fa-android" style="font-size: 64px;color: gray;"></i></a>
                            </div>
                            <div class="col-lg-6 col-6 text-center">
                                <a href="https://apps.apple.com/app/sfi-dms-safety-app/id1466584086" target="_blank"><i class="fa fa-apple" style="font-size: 64px;color: gray;"></i></a>
                            </div>
                        </div>


                        <ul class="smallfontsize">
                            <li><i class="fa fa-circle facirclesize"></i><span class="smallfontsize">&nbsp;Enter their own safety inspections.</span></li>
                        </ul>
                        <ul class="smallfontsize">
                            <li><i class="fa fa-circle facirclesize"></i><span class="smallfontsize">&nbsp;Record regular safety observations.</span></li>
                        </ul>
                        <ul class="smallfontsize">
                            <li><i class="fa fa-circle facirclesize"></i><span class="smallfontsize">&nbsp;Document Tool Box Talks.</span></li>
                        </ul>
                    </div>
                </div>
            </div> -->

        </div>
    </div>
</section>